/**
 * Minimal RFC-compatible email pattern used for client-side gating.
 * The BE applies stricter validation via class-validator's `@IsEmail` —
 * this is the loose check we use to enable/disable Save and surface row-level errors.
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string): boolean => EMAIL_REGEX.test(value);
